/**
 * Format learner account ID to display format: C0123456789-00001 or R0123456789-00001
 */
export const formatLearnerAccountId = (
  rsoId?: string | number | null,
  companyId?: string | number | null,
  learnerId?: string | number | null,
): string | null => {
  if (!learnerId) {
    return null;
  }

  const orgId = rsoId || companyId;
  if (!orgId) {
    return null;
  }

  const prefix = rsoId ? "R" : "C";
  const paddedOrgId = String(orgId).padStart(10, "0");
  const paddedLearnerId = String(learnerId).padStart(5, "0");

  return `${prefix}${paddedOrgId}-${paddedLearnerId}`;
};
